import React from 'react';
import { Link } from 'react-router-dom';

const BemVindo = () => {
  return (
<div>
  <h1>Bem Vindo</h1>
  
  <div id = "texto2">  
   
  
  <Link to="/solucoes"  id="link_css">
  <p>
    <b>Soluções</b><br/>
  Criando sempre a melhor solução para alcançar os melhores resultados
  </p>
  </Link>
  <br/>
  <Link to="/segmentos" id="link_css">
  <p>
  <b>Segmentos</b><br/>
  Padarias; Café, Doces e Bolos; Restaurantes;  Pizzarias;  Sorveteria;  Loja de Vinhos; Estética; Perfumes,
   Cosméticos; Roupas; Calçados; Acessórios; Mercados, Minimercados, Hortifrúti; Açougues, Peixaria; 
   Material de Construção; Conveniência; Estacionamentos; Lava Rapido; Posto de Abastecimento.
  </p>
  </Link>
  <br/>
  <Link to="/area"  id='link_css' >
  <p>
  <b>Acesso ao Sistema</b><br/>
  PDV, Retaguarda e Administrativo.
  </p>
  </Link>

  </div>

</div>
   )
  };
export default BemVindo;
